<template>
  <sc-render :fields="fields" :emptyMessage="$t('NO_DATA_SOURCE_EXIST')">
    <div class="body-editorial-block-video" v-if="rendering.dataSource && !isEmpty">
      <div :class="{ 'editorial-content' : wrapVideo }">
        <header-video class="body-editorial-video" :params="params" :fields="fields"/>
      </div>
    </div>
  </sc-render>
</template>

<script>
import { Placeholder, RichText } from '@sitecore-jss/sitecore-jss-vue'
import { createNamespacedHelpers } from 'vuex'
import isEmptyObject from '~/helpers/is-empty-object'
import HeaderVideo from '../header-video-editorial'
import ScRender from '../sc-render'

const { mapGetters: mapJssGetters } = createNamespacedHelpers('jss')

export default {
  name: 'BodyEditorialVideo',
  props: {
    fields: {
      type: Object,
      default: () => ({})
    },
    params: {
      type: Object
    },
    rendering: {
      type: Object
    }
  },
  components: {
    scPlaceholder: Placeholder,
    ScRichText: RichText,
    HeaderVideo,
    ScRender
  },
  computed: {
    ...mapJssGetters(['isEditMode']),
    wrapVideo () {
      return !!(this.params.videoWidth && this.params.videoWidth === 'cropped')
    },
    isEmpty () {
      return isEmptyObject(this.fields)
    }
  }
}
</script>

<style lang="scss" scoped>
.body-editorial-block-video {
  position: relative;
  margin-bottom: $space-080;
    @include tablet {
        margin-bottom: $space-090;
    }

  .editorial-content {
    position: relative;
    max-width: 44em;
    margin: 0 $space-060;
    @include tablet {
      width: 80%;
      margin: 0 auto;
    }

    .text-wrapper {
      position: relative;

      .paragraph {
        @include font('060');
        font-stretch: normal;
        letter-spacing: normal;
        color: $color-black;
        margin: $space-080 0;

        @include tablet {
          margin: $space-060 0 $space-090;
        }
      }
    }
  }
}
</style>
